module.exports = __webpack_public_path__ + "static/media/inventory-header.b90ac442.png";